
import { Component, OnInit, Inject,ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService, AlertService, AdminService, LeadService } from '../../_services/';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-add-note-dialog',
  templateUrl: './add-note-dialog.component.html',
  styleUrls: ['./add-note-dialog.component.scss']
})
export class AddNoteDialogComponent implements OnInit {
  addNoteForm:FormGroup;
  submitted:Boolean = false;
  hour12Timer:Boolean=true;
  constructor(
    public dialogRef: MatDialogRef<AddNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService,
    private _lead : LeadService,
    private _toastr : ToastrService

  ) { }

  ngOnInit() {
    this.addNoteForm = this.formBuilder.group({
      // note_date_time: [null, []],
      body:[null,[]]
    })
  }



  hideAddNoteDialog(){
    this.dialogRef.close();
  }

  onFormSubmit(){
    this.submitted = true;
    if (this.addNoteForm.invalid) {
      return;
    } 
    let form = this.addNoteForm.value;
    // form.note_date_time = new Date(form.note_date_time).getTime();
    form.contact_id = this.data.contact_id ? this.data.contact_id : null;
    form.project_id = this.data.project_id ? this.data.project_id : null;
    form.author_user_id = localStorage.getItem('uid');
    // form.date_created = new Date().getTime();
    this._common.showLoader(true);

    this._lead.addNote(form).then(res => {
      this._common.showLoader(false);
      this.dialogRef.close();
      this._toastr.success(`Note added successfully!`,"",{ timeOut: 4000 });
    })
    .catch(error=>{
      this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
    })   
  }

}
